// Per-game tuning for the anticipation BACKGROUND soft-light overlay
// (presentation/AnticipationBackground). While a server-flagged reel teases, the
// background's soft-light ColorOverlayFilter `strength` creeps toward maxStrength (continuous, like
// the grid zoom), then snaps back when the last flagged reel lands. `strength` is the filter's
// 0..1 uniform; durations are SECONDS. createPresentation passes it to
// AnticipationBackground.setTuning and ducks the music by musicDuckScale.

export interface AnticipationBackgroundTuning {
  /** Start the overlay from the Nth anticipated reel, 1-based (2 = skip the first reel's tease; a
   *  single-reel tease then shows no overlay). */
  startFromReel: number;
  /** Seconds to wait after the tease starts before the overlay begins creeping (0 = immediate). */
  preDelaySeconds: number;
  /** Strength gained per second while anticipating (continuous creep toward maxStrength). */
  creepPerSecond: number;
  /** Cap on the overlay strength (0..1). 1 = full soft-light overlay. */
  maxStrength: number;
  /** Seconds to snap the strength back to 0 when the tease ends ("drop fast"). */
  downSeconds: number;
  /** Hold at peak strength after the last flagged reel lands, BEFORE the drop begins (the "held
   *  breath" — mirrors the grid zoom's downStartDelaySeconds). 0 = drop immediately on land. */
  downStartDelaySeconds: number;
  /** Music-bus duck multiplier while a flagged reel teases (0..1; 1 = no duck). The
   *  music dips to this under the anticipation roll, restored when the tease ends. */
  musicDuckScale: number;
}

export const ANTICIPATION_BACKGROUND_TUNING: AnticipationBackgroundTuning = {
  startFromReel: 1, // overlay lights from the 1st anticipated reel, so every tease shows it (a single-reel one too)
  preDelaySeconds: 0.2, // hold a beat after the tease starts before the overlay lights up
  creepPerSecond: 0.4, // ~2s to reach full (1) during a sustained tease
  maxStrength: 1, // full soft-light overlay at the peak
  downStartDelaySeconds: 0.15, // hold at peak this long after the last land, then drop
  downSeconds: 0.3, // fast snap-back on the last land
  musicDuckScale: 0.35, // dip music to 35% under the tease — tune in playtest
};
